<template>
  <div>
    <!-- Title and Description -->
    <div class="mb-4">
      <h5 class="text-dark fw-bold">
        {{ $t('master.user.setVerification.title') }}
      </h5>
      <p class="text-muted mb-3">
        {{ $t('master.user.setVerification.description') }}
      </p>
    </div>

    <!-- Verification Options -->
    <b-form-group>
      <!-- WhatsApp Option -->
      <div
        class="mc-user-modal__password-method-card mb-3"
        :class="{
          'mc-user-modal__password-method-card--selected':
            form.setVerification === 'phoneNumber' && form.phoneNo,
          'mc-user-modal__password-method-card--disabled': !form.phoneNo || form.isPhoneVerified,
        }"
        @click="form.phoneNo && updateVerificationMethod('phoneNumber')"
      >
        <div class="d-flex align-items-center justify-content-between p-3">
          <div class="d-flex align-items-center">
            <b-form-radio
              v-model="verificationValue"
              plain
              value="phoneNumber"
              class="me-3"
              :disabled="!form.phoneNo"
              @change="updateVerificationMethod('phoneNumber')"
            />
            <i
              class="icon-outline_whatsapp me-3 mc-user-modal__icon-whatsapp"
              :class="{ 'mc-user-modal__icon--muted': !form.phoneNo }"
            />
            <span :class="{ 'text-muted': !form.phoneNo }">
              {{ $t('master.user.whatsappTo') }}
            </span>
          </div>
          <span :class="{ 'text-muted': !form.phoneNo }">
            {{ form.phoneNo ? `+${form.phoneNo}` : '-' }}
          </span>
        </div>
      </div>

      <!-- Email Option -->
      <div
        v-if="!form.isEmailVerified"
        class="mc-user-modal__password-method-card mb-3"
        :class="{
          'mc-user-modal__password-method-card--selected':
            form.setVerification === 'email' && form.email,
          'mc-user-modal__password-method-card--disabled': !form.email || form.isEmailVerified,
        }"
        @click="form.email && updateVerificationMethod('email')"
      >
        <div class="d-flex align-items-center justify-content-between p-3">
          <div class="d-flex align-items-center">
            <b-form-radio
              v-model="verificationValue"
              plain
              value="email"
              class="me-3"
              :disabled="!form.email"
              @change="updateVerificationMethod('email')"
            />
            <i
              class="icon-outline_email me-3 mc-user-modal__icon-email"
              :class="{ 'mc-user-modal__icon--muted': !form.email }"
            />
            <span :class="{ 'text-muted': !form.email }">
              {{ $t('master.user.emailTo') }}
            </span>
          </div>
          <span :class="{ 'text-muted': !form.email }">
            {{ form.email || '-' }}
          </span>
        </div>
      </div>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'SetVerificationForm',

  props: {
    form: {
      type: Object,
      required: true,
    },
  },

  computed: {
    verificationValue: {
      get() {
        return this.form.setVerification
      },
      set(val) {
        this.$emit('update-form', {
          ...this.form,
          setVerification: val,
        })
      },
    },
  },

  methods: {
    updateVerificationMethod(method) {
      this.$emit('update-form', { setVerification: method })
    },
  },
}
</script>
